var _defs, _rect, _path, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "brandGrad",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ff7233"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#ea3d05"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    rx: 120,
    fill: "url(#brandGrad)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M155 210c0-30 24-54 54-54h94c30 0 54 24 54 54v92c0 30-24 54-54 54h-56l-46 40v-40h1c-30 0-47-24-47-54z",
    fill: "#ffffff",
    opacity: 0.95
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 205,
    cy: 256,
    r: 14,
    fill: "#ea3d05"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 14,
    fill: "#ea3d05"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 307,
    cy: 256,
    r: 14,
    fill: "#ea3d05"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.3e9fea459a2c153b3ddccb8e49170cc6.svg";
export { ForwardRef as ReactComponent };